export default {
  'Host targeting': 'rgb(6, 160, 155)',
  'Host-targeting': 'rgb(6, 160, 155)',
  'Direct antiviral': 'rgb(255, 158, 183)',
  'Direct virus-targeting ': 'rgb(207, 223, 255)',
  Homeopathy: 'rgb(207, 223, 255)',
  'Not confirmed': 'rgb(255, 158, 183)',
}
